<template>
  <section class="logo-strip" data-testid="soldera-logo-strip">
    <div class="row g-4 align-items-center">
      <div class="col-lg-3">
        <p class="strip-title font-serif mb-2">
          {{ $t("signup.proof.title") }}
        </p>
        <div class="d-flex flex-wrap gap-3">
          <div v-for="stat in STATS" :key="stat.labelKey">
            <div class="strip-stat font-serif">{{ stat.value }}</div>
            <div class="strip-muted small">{{ $t(stat.labelKey) }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-9 d-flex flex-column gap-4">
        <div>
          <p class="strip-label">{{ $t("billing.proof.used_by") }}</p>
          <LogoMarqueeComponent :logos="CUSTOMER_LOGOS" />
        </div>
        <div>
          <p class="strip-label">
            {{ $t("billing.proof.recognised_backed_by") }}
          </p>
          <LogoMarqueeComponent :logos="RECOGNISED_LOGOS" smallPrint />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import LogoMarqueeComponent from "@/components/proof/LogoMarqueeComponent.vue";
import {
  CUSTOMER_LOGOS,
  RECOGNISED_LOGOS,
} from "@/components/proof/solderaLogos";

// Who uses and backs Soldera, in the dark band soldera.org uses for proof. Shown under the signup pages.

// Approved floors, written with space-separated thousands as the design system asks.
const STATS = [
  { value: "1 000+", labelKey: "billing.proof.stats.clients" },
  { value: "6 000+", labelKey: "billing.proof.stats.plants" },
];
</script>

<style scoped lang="scss">
.logo-strip {
  padding: 2rem;
  border-radius: 12px;
  background: #2d3e37;
  color: #ffffff;
}

.strip-title {
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.2;
}

.strip-stat {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.1;
}

.strip-muted {
  color: #b8d0bf;
}

.strip-label {
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #b8d0bf;
  margin-bottom: 0.75rem;
}
</style>
